import api from '@/api/index.js';

export default {
    SET_MSGNUM({ commit }, data) {
        commit('SET_MSGNUM', data)
    },
    // SET_MSGNUM({ commit }) {
    //     return new Promise((resolve) => {
    //         api.queryNoRead().then((res) => {
    //             if (res.data.code == 0) {
    //               commit('SET_MSGNUM', res.data.data)
    //               resolve()
    //             } else {
    //               this.$message.error(res.data.message)
    //             }
    //         })
    //     })
    // },
    GET_MSGNUM({ commit }, data) {
        commit('ADD_MSGNUM', data)
    },
    CUT_MSGNUM({ commit }) {
        commit('CUT_MSGNUM')
    },
}



// WEBPACK FOOTER //
// ./src/store/actions.js